module.exports = __webpack_public_path__ + "img/enjoy_black_icon.9a41045f.png";